
export const hasWindow = () => typeof window !== 'undefined';

export const msg = (field: string) => `Please enter a valid ${field}`;

export const firstLetterCapitalize = (str: string) => {
	return str.charAt(0).toUpperCase() + str.slice(1);
};

